module.exports = __webpack_public_path__ + "vue/img/upload-tx.216756d3.png";